// extracted by mini-css-extract-plugin
export var body = "card--time-module--body--b0366";
export var bookingInfo = "card--time-module--booking-info--d0610";
export var bookingRequired = "card--time-module--booking-required--6e20c";
export var card = "card--time-module--card--bb79b";
export var content = "card--time-module--content--f9a49";
export var detailPill = "card--time-module--detail-pill--85e11";
export var time = "card--time-module--time--260f0";
export var title = "card--time-module--title--8ca29";